module.exports = __webpack_public_path__ + "assets/img/excel.ebd68159.svg";